// © Microsoft Corporation. All rights reserved.

import { Activities, Content, ReactionBreakdownData, TypingUser, UGContent, UGContentListView, User, UserList } from "@msnews/social-data-service";

import { ActionMap } from "@msnews/experiences-redux";

export type SetTheme = (theme?: string) => void;
export type UpdateMe = (me: User) => void;
export type UpdateNotifications = (notifications: Activities) => void;
export type UpdateActivities = (activities: Activities) => void;
export type DeleteActivities = () => void;
export type UpdateActivityStatus = (id: string, read: boolean) => void;
export type UpdateActivityAppeal = (id: string, appealSent: boolean) => void;
export type SetContent = (content: Content, id: string) => void;
export type UpdateContent = (contentId: string, data: any) => void;
export type UpdateContentRating = (contentId: string, rating: String) => void;
export type InsertComments = (contentId: string, comments: Object, page: boolean, parentId?: String, prepend?: boolean) => void;
export type ResetSpecificCommentId = () => void;
export type IncrementReplyCount = (contentId: string, commentId?: string) => void;
export type UpdateCommentRating = (contentId: string, commentId: string, rating: String, updateCounts: boolean) => void;
export type InsertComment = (contentId: string, comment: Object, parentId?: String, addedOffline?: boolean) => void;
export type UpdateUser = (userId: String, user: Object) => void;
export type UpdateUserFollowers = (userId: String, followers: UserList) => void;
export type UpdateUserFollowing = (userId: String, following: UserList) => void;
export type UpdateUserComments = (userId: String, comments: Array<Object>, reset: boolean) => void;
export type DeleteUserComment = (userId: String, commentId: string, parentId: string) => void;
export type SetReactionBreakdown = (data: ReactionBreakdownData) => void;
export type SetGradientOverlayData = (data: any) => void;
export type SetPublisherSubscribeFollowButtonData = (data: any) => void;
export type SetPopup = (moduleName: string, props: Object) => void;
export type AddTyper = (typer: TypingUser, contentId: string, id: string, market: string) => void;
export type UpdateTypers = (expireTime: number) => void;
export type RecordSignalRHub = (contentId: string) => void;
export type UpdateUGContents = (ugContents: UGContentListView, userId: string) => void;
export type UpdateUGContent = (ugContent: UGContent) => void;
export type PublishUGContent = () => void;
export type UnPublishUGContent = () => void;
export type DeleteUGContent = (id: string) => void;
export type UpdateResponsiveClass = (responsiveClass: string) => void;
export type DeleteMyData = () => void;
export type MapCmsIdToContentId = (cmsId: string, market: string, contentId: string) => void;
export type ResetError = () => void;

export const SocialDataActions = {
    setTheme: new ActionMap<SetTheme>("SetTheme"),
    updateMe: new ActionMap<UpdateMe>("UpdateMe"),
    updateNotifications: new ActionMap<UpdateNotifications>("UpdateNotifications"),
    updateActivities: new ActionMap<UpdateActivities>("UpdateActivities"),
    deleteActivities: new ActionMap<DeleteActivities>("DeleteActivities"),
    updateActivityStatus: new ActionMap<UpdateActivityStatus>("UpdateActivityStatus"),
    setContent: new ActionMap<SetContent>("SetContent"),
    updateContent: new ActionMap<UpdateContent>("UpdateContent"),
    updateContentRating: new ActionMap<UpdateContentRating>("UpdateContentRating"),
    insertComments: new ActionMap<InsertComments>("FetchContentComments"),
    resetSpecificCommentId: new ActionMap<ResetSpecificCommentId>("ResetSpecificCommentid"),
    updateCommentRating: new ActionMap<UpdateCommentRating>("UpdateCommentRating"),
    incrementReplyCount: new ActionMap<IncrementReplyCount>("IncrementReplyCount"),
    insertComment: new ActionMap<InsertComment>("InsertComment"),
    updateUser: new ActionMap<UpdateUser>("UpdateUser"),
    updateUserFollowers: new ActionMap<UpdateUserFollowers>("UpdateUserFollowers"),
    updateUserFollowing: new ActionMap<UpdateUserFollowing>("UpdateUserFollowing"),
    updateUserComments: new ActionMap<UpdateUserComments>("UpdateUserComments"),
    deleteUserComment: new ActionMap<DeleteUserComment>("DeleteUserComment"),
    setReactionBreakdown: new ActionMap<SetReactionBreakdown>("SetReactionBreakdown"),
    setGradientOverlayData: new ActionMap<SetGradientOverlayData>("SetGradientOverlayData"),
    setPublisherSubscribeFollowButtonData: new ActionMap<SetPublisherSubscribeFollowButtonData>("SetPublisherSubscribeFollowButtonData"),
    setPopup: new ActionMap<SetPopup>("SetPopup"),
    addTyper: new ActionMap<AddTyper>("AddTyper"),
    updateTypers: new ActionMap<UpdateTypers>("UpdateTypers"),
    recordSignalRHub: new ActionMap<RecordSignalRHub>("RecordSignalRHub"),
    updateUGContents: new ActionMap<UpdateUGContents>("UpdateUGContents"),
    updateUGContent: new ActionMap<UpdateUGContent>("UpdateUGContent"),
    publishUGContent: new ActionMap<PublishUGContent>("PublishUGContent"),
    unPublishUGContent: new ActionMap<UnPublishUGContent>("UnPublishUGContent"),
    deleteUGContent: new ActionMap<DeleteUGContent>("DeleteUGContent"),
    updateResponsiveClass: new ActionMap<UpdateResponsiveClass>("UpdateResponsiveClass"),
    deleteMyData: new ActionMap<DeleteMyData>("DeleteMyData"),
    updateActivityAppeal: new ActionMap<UpdateActivityAppeal>("UpdateActivityAppeal"),
    mapCmsIdToContentId: new ActionMap<MapCmsIdToContentId>("MapCmsIdToContentId"),
    resetError: new ActionMap<ResetError>("ResetError")
};